module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO7_11 (18).2278b47.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO7_11 (18).mp4
// module id = 793
// module chunks = 1